<div #titleElement mat-dialog-title class="pe-2">
  <button mat-dialog-close="" mat-icon-button i18n-title title="Back">
    <ft-icon name="arrow-left" class="ft-icon--2" />
  </button>
  <div class="ft-header__title">{{ page()?.data?.attributes?.title }}</div>
</div>
<div mat-dialog-content class="pt-4">
  <div
    class="ft-observe-interseting"
    (ftObserveIntersecting)="
      appService.setOverlapped($event, titleElement)
    "></div>
  <div
    class="ft-html-section"
    [innerHTML]="page()?.data?.attributes?.body?.value"></div>
</div>
